import React from 'react';
import { ChartRange } from '../../../entities';
import { ControlButton } from '../../shared/Button';

interface Props {
  isActive: boolean;
  changeRange: (range: ChartRange) => void;
  range: ChartRange;
}

const Interval = ({ changeRange, isActive, range }: Props) => {
  const change = () => {
    changeRange(range);
  };

  return (
    <ControlButton $isActive={isActive} onClick={change}>
      {range}
    </ControlButton>
  );
};

export default Interval;
